// 22.01.19 - This simple component simply displays a full-width div
// with a centered CircularProgress indicator -- used for displaying a loading screen. Used in form and view cases.
import { CircularProgress } from "@material-ui/core";
import * as React from "react";

export const Loading = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        minHeight: "80vh"
      }}
    >
      <CircularProgress size={55} />
    </div>
  );
};
